import React from 'react'
import PropTypes from 'prop-types'
import { Popover, makeStyles } from '@material-ui/core'
import EventChip from './EventChip'

const useStyles = makeStyles({
  content: {
    width: 260,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  heading: {
    fontSize: 13,
    fontWeight: 600,
    color: '#0d0d0d',
    marginBottom: 4,
  },
})

const DayEventsPopover = ({ day, events, anchorEl, onClose, onEventClick }) => {
  const styles = useStyles()
  const handleEventClick = onEventClick
    ? (event) => {
        onEventClick(event)
        onClose()
      }
    : undefined

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <div className={styles.content}>
        <div className={styles.heading}>{day.format('MMM D, YYYY')}</div>
        {events.map((event) => (
          <EventChip key={event.id} event={event} onClick={handleEventClick} />
        ))}
      </div>
    </Popover>
  )
}

DayEventsPopover.propTypes = {
  day: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onEventClick: PropTypes.func,
}

DayEventsPopover.defaultProps = {
  anchorEl: null,
  onEventClick: undefined,
}

export default DayEventsPopover
